import { v4 as uuid } from "uuid";
import { formatDate } from "../utils/authUtils";
/**
 * User Database can be added here.
 * You can add default users of your wish with different attributes
 * */

export const users = [
  {
    _id: uuid(),
    firstName: "Ravi",
    lastName: "Yadav",
    username: "raviyadav4013@gmail.com",
    password: "123",
    userHandler: "RaviYadav",
    profilePic:
      "https://i.ibb.co/RNn86rM/pic-1.jpg",
    link: "https://github.com/RaviYadav3003",
    bio: "An aspiring web developer in NeoG",
    bookmarks: [],
    followers: [],
    following: [],
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Rahul",
    lastName: "Yadav",
    username: "rahulyadav@gmail.com",
    password: "rahul123",
    userHandler: "rahuly",
    profilePic:
      "https://i.ibb.co/DMRD10P/pic-2.jpg",
    link: "",
    bio: "",
    bookmarks: [],
    followers: [],
    following: [],
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "kajol",
    lastName: "gupta",
    username: "kajolgupta12@gmail.com",
    password: "kajol",
    userHandler: "kaju",
    profilePic:
      "https://i.ibb.co/J5yrW9W/pic5.webp",
    link: "",
    bio: "",
    bookmarks: [],
    followers: [],
    following: [],
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "john",
    lastName: "lobo",
    username: "johnlobo@gmail.com",
    password: "johnl0",
    userHandler: "johnny",
    profilePic:
      "https://i.ibb.co/ByYsWQ1/pic-6.jpg",
    bookmarks: [],
    followers: [],
    following: [],
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Rohit",
    lastName: "Yadav",
    username: "rohityadav@gmail.com",
    password: "rohit112",
    userHandler: "rohit",
    profilePic:
      "https://i.ibb.co/9bcJ2k9/pic-3.jpg",
    bookmarks: [],
    followers: [],
    following: [],
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Neha",
    lastName: "Hule",
    username: "nehahule@gmail.com",
    password: "neha12",
    userHandler: "neha",
    profilePic:
      "https://i.ibb.co/3rCM9bj/pic-4.jpg",
    bookmarks: [],
    followers: [],
    following: [],
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Itachi",
    lastName: "Uchiha",
    username: "itachiuchiha@gmail.com",
    password: "itachi12",
    userHandler: "itachiuchiha",
    profilePic: "https://i.ibb.co/QvkJT63/naruto-shippuuden-uchiha-itachi-sharingan-anime-wallpaper-preview.jpg",
    bookmarks: [],
    followers: [],
    following: [],
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
  {
    _id: uuid(),
    firstName: "Naruto",
    lastName: "Uzamaki",
    username: "narutouzamaki@gmail.com",
    password: "naruto12",
    userHandler: "naruto",
    profilePic: "https://i.ibb.co/sWCGdvx/uchiha-itachi-naruto-shippuuden-anbu-silhouette-wallpaper-preview.jpg",
    bookmarks: [],
    followers: [],
    following: [],
    createdAt: formatDate(),
    updatedAt: formatDate(),
  },
];
